import { render } from "./RescueAlliance.vue?vue&type=template&id=6850532c&scoped=true"
import script from "./RescueAlliance.vue?vue&type=script&lang=js"
export * from "./RescueAlliance.vue?vue&type=script&lang=js"

import "./RescueAlliance.vue?vue&type=style&index=0&id=6850532c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6850532c"]])

export default __exports__